const styles = {
  dateTimeContainer: {
    display: 'flex',
    width: '100%',
  },
  inputContainer: {
    flex: '0 1 46%',
    marginBottom: '15px',
  },
  calendarContainer: {
    border: '1px solid #D4DBE4',
    backgroundColor: 'white',
    borderRadius: '6px',
    width: '100%'
  },
  calendarStyles: {
    allDay: {
      fontSize: '12px',
      borderRadius: '4px',
      boxSizing: 'border-box',
      textAlign: 'center',
    },
    highlighted: {
      color: 'white',
      backgroundColor: '#2F68FD',
    },
  },
  readOnly: {
    cursor: 'not-allowed',
    backgroundColor: '#d4d4d4',
    pointerEvents: 'none',
  },
  weekDay: {
    fontSize: '12px',
    color: '#6E84A3',
  },
  arrowButton: {
    position: 'absolute',
    top: '18px',
    right: '30px',
  },
  displayColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  arrowBackButton: {
    fontSize: '15px',
    color: '#12253F',
    marginRight: '5px',
  },
  arrowForwardButton: {
    fontSize: '15px',
    color: '#12253F',
  },
  arrowBackDisabledStyle: {
    color: '#D4DBE4',
    fontSize: '15px',
    marginRight: '5px',
  },
  disabled: {
    cursor: 'not-allowed',
    opacity: '.1',
    pointerEvents: 'none'
  },
  notDisabled: {
  }
};

export default styles;
